import {FlatButton, TextField} from 'material-ui';
import React, {Component} from 'react';
import styled from 'styled-components';

import { HeadlineH1 } from '../arkulpa-fec/components/Text';
import { convertErrors } from '../arkulpa-fec/utils/errorHelper';
import ActionButtonRow from '../arkulpa-fec/components/ActionButtonRow';
import ErrorMessage from '../arkulpa-fec/components/ErrorMessage';
import filterOutNotDefinedValues from
  '../arkulpa-fec/utils/filterOutNotDefinedValues';

const HalfWidth = styled.div`
  width: 50%;
`;

export default class extends Component {
  constructor(props) {
    super(props);
    let project = {};
    if (props.data && props.data.project) {
      project = props.data.project;
    }
    this.state = {
      name: '',
      key: '',
      ...filterOutNotDefinedValues(project),
    };
  }

  componentWillReceiveProps = newProps => {
    if (newProps.data.error) {
      const {graphQLErrors} = newProps.data.error || {};
      this.setState({errors: graphQLErrors});
    } else {
      const {user} = newProps.data || {};
      this.setState({errors: [], ...filterOutNotDefinedValues(user)});
    }
  };
  _goBackToList = () => {
    let {length, goBack, replace} = this.props.history;
    if (length > 2) {
      goBack();
    } else {
      replace('/projects');
    }
  };

  _renderHeadline = () => {
    if (this._isNew()) {
      return <HeadlineH1>New Project</HeadlineH1>;
    }
    return <HeadlineH1>Edit Project</HeadlineH1>;
  };

  _isNew = () => !this.state._id;

  _save = () => {
    let {...state} = filterOutNotDefinedValues(this.state);

    this.setState({savingStatus: 'saving Project'});
    this.props
      .save({
        ...state,
      })
      .then(() => {
        this.setState({savingStatus: undefined});
        this._goBackToList();
      })
      .catch(rawErrors => {
        this.setState({savingStatus: undefined});
        let errors = convertErrors(rawErrors);
        this.setState({errors});
        console.log('there was an error sending the query', errors);
      });
  };

  _renderButtons = () => {
    let {savingStatus} = this.state;
    let isSaving = !!savingStatus;
    return (
      <ActionButtonRow>
        <FlatButton onClick={this._goBackToList} label="Back to list" />
        <FlatButton primary onClick={this._save} label={isSaving ? savingStatus : 'save'} disabled={isSaving} />
      </ActionButtonRow>
    );
  };

  render() {
    let {name, key} = this.state;
    return (
      <div>
        <ErrorMessage errors={this.state.errors} clearErrors={() => this.setState({errors: []})} />
        {this._renderHeadline()}
        <HalfWidth>
          <TextField
            type="text"
            fullWidth={true}
            floatingLabelText="Project name*"
            value={name}
            onChange={({target: {value}}) => this.setState({name: value})}
          />
        </HalfWidth>
        <HalfWidth>
          <TextField
            type="text"
            fullWidth={true}
            floatingLabelText="Project key*"
            value={key}
            onChange={({target: {value}}) => this.setState({key: value})}
          />
        </HalfWidth>
        {this._renderButtons()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ProjectForm.js